import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MessagesEventPage } from './messages-event';

@NgModule({
  declarations: [
    MessagesEventPage,
  ],
  exports:[
    MessagesEventPage,
  ],
  imports: [
    IonicPageModule.forChild(MessagesEventPage),
  ],
})
export class MessagesEventPageModule {}



// WEBPACK FOOTER //
// ./src/pages/messages-event/messages-event.module.ts